import {useState} from "react";
import {useLocation, useOutletContext, useParams} from "react-router-dom";

import {useNavigateWithReload} from "base/hooks";
import EditIcon from "@mui/icons-material/Edit";
import {EDARForm} from "../presentational/form";
import {SectionCardHeaderAction} from "base/component/presentational";
import {EDARService} from "saneamiento/service";
import {edar_view_adapter} from "saneamiento/model";
import {EDARLocationSection} from "../presentational/section";
import {SisbagalSectionCard} from "sisbagal/auth";

const UpdateEDARGeoPanel = () => {
    const {section} = useParams();
    const location = useLocation();
    const baseLocationPath = location.pathname.split(section)[0];

    const [mode, setMode] = useState("view");
    const [error, setError] = useState("");
    const navigate = useNavigateWithReload();

    let edar;
    [edar] = useOutletContext();

    const handleSubmit = edar => {
        EDARService.update(edar_view_adapter({...edar}))
            .then(() => {
                navigate(location.pathname, true);
            })
            .catch(error => {
                setError(error);
            });
    };

    const handleFormCancel = () => {
        setMode("view");
    };

    const secondaryActions = [
        <SectionCardHeaderAction
            key="edit"
            name="edit"
            text="Modificar"
            icon={<EditIcon />}
            onClick={() => {
                setMode("edit");
            }}
            roles={[]}
        />,
    ];

    return (
        <SisbagalSectionCard title="Ubicación" secondaryActions={secondaryActions}>
            {mode === "edit" ? (
                <EDARForm
                    edar={edar}
                    updatedSection="geo"
                    onSubmit={handleSubmit}
                    onCancel={handleFormCancel}
                />
            ) : (
                <EDARLocationSection edar={edar} />
            )}
        </SisbagalSectionCard>
    );
};

export default UpdateEDARGeoPanel;
